'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _glamorReact = require('glamor-react');

var _colors = require('../styles/colors');

var _flex = require('../styles/flex');

var _flex2 = _interopRequireDefault(_flex);

var _helpers = require('../styles/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _glamorReact.css)((0, _flex2.default)({ direction: 'column' }), (0, _glamorReact.select)('& label', _extends({}, (0, _colors.text)(_colors.COLORS.GREY), (0, _helpers.font)('1rem'), {
  paddingLeft: 0
})), (0, _glamorReact.select)('& select', (0, _glamorReact.merge)((0, _glamorReact.focus)({ outline: 'none' }), (0, _colors.background)(_colors.COLORS.WHITE), (0, _helpers.font)('1rem'), (0, _helpers.border)(1, _colors.COLORS.BLUE))), (0, _glamorReact.select)('& *', (0, _helpers.padding)('.5rem')));


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Dropdown/styles.js
// module id = 1583
// module chunks = 0